import React from "react";

const Warning = (props) => {
    return (
        <div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height={props.height ?? "24" }
                viewBox="0 -960 960 960"
                width={props.width ?? "24" }
                fill="rgb(255,147,49)"
            >
                <path
                    stroke="#000000"
                    strokeWidth="5px"
                    d="M92-120q-9 0-15.652-4.125Q69.696-128.25 66-135q-4.167-6.6-4.583-14.3Q61-157 66-165l388-670q5-8 11.5-11.5T480-850q8 0
                        14.5 3.5T506-835l388 670q5 8 4.583 15.7-.416 7.7-4.583 14.3-3.696 6.75-10.348 10.875Q877-120 868-120H92Zm52-60h672L480-760 144-180Zm340.175-57q12.825
                        0 21.325-8.675 8.5-8.676 8.5-21.5 0-12.825-8.675-21.325-8.676-8.5-21.5-8.5-12.825 0-21.325 8.675-8.5 8.676-8.5 21.5 0 12.825 8.675 21.325 8.676 8.5 21.5
                        8.5Zm0-111q12.825 0 21.325-8.625T514-378v-164q0-12.75-8.675-21.375-8.676-8.625-21.5-8.625-12.825 0-21.325 8.625T454-542v164q0 12.75 8.675 21.375 8.676 8.625 21.5 8.625ZM480-470Z"
                />
            </svg>
        </div>
    );
};

export default Warning;
